/**
 * @param {Array<{ header?: string }>} columns
 * @returns {Map<string, number>}
 */
export function findDuplicateHeaders(columns) {
  const counts = new Map();
  for (const col of columns) {
    const h = String(col.header || '').trim();
    if (!h) continue;
    counts.set(h, (counts.get(h) || 0) + 1);
  }
  const dupes = new Map();
  for (const [header, count] of counts) {
    if (count > 1) dupes.set(header, count);
  }
  return dupes;
}

/**
 * @param {import('./config_schema.js').PortalConfig} config
 * @returns {{ messages: string[], tone: 'ok'|'warn'|'neutral' }}
 */
export function hintsForConfig(config) {
  const messages = [];
  const columns = config.sheet?.columns || [];
  const dupes = findDuplicateHeaders(columns);
  const lookupRef = config.sheet?.lookup?.reference || 'header';
  const lookupHeader = String(config.sheet?.lookup?.header || '').trim();

  if (dupes.size > 0) {
    const names = [...dupes.keys()].slice(0, 3).join('", "');
    messages.push(
      `"${names}" appears more than once. Header mode uses the first match only. Try Column letter or Column number for those fields.`
    );
  } else if (columns.length > 0 && lookupRef === 'header') {
    messages.push('Headers look unique. Header mode is a good fit for your lookup column.');
  }

  if (lookupRef === 'header' && lookupHeader && dupes.has(lookupHeader)) {
    messages.push(
      `Your lookup column "${lookupHeader}" is duplicated. Consider switching lookup to Column letter or Column number.`
    );
  }

  const emptyHeaders = columns.filter((c) => !String(c.header || '').trim()).length;
  if (emptyHeaders > 0) {
    messages.push(
      `${emptyHeaders} column(s) have no header name. Column letter or number is usually easier.`
    );
  }

  if (messages.length === 0) {
    return { messages: [], tone: 'neutral' };
  }

  const tone =
    dupes.size > 0 || (lookupRef === 'header' && lookupHeader && dupes.has(lookupHeader))
      ? 'warn'
      : messages.some((m) => m.includes('good fit'))
        ? 'ok'
        : 'neutral';

  return { messages, tone };
}
